export default "__VITE_ASSET__Ciq8hAJA__"